import { render, staticRenderFns } from "./refundApproval.vue?vue&type=template&id=002dfff2&scoped=true"
import script from "./refundApproval.vue?vue&type=script&lang=js"
export * from "./refundApproval.vue?vue&type=script&lang=js"
import style0 from "./refundApproval.vue?vue&type=style&index=0&id=002dfff2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002dfff2",
  null
  
)

export default component.exports